import Splide from '@splidejs/splide';
import '@splidejs/splide/css';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

const splideSetting = (): void => {
  const splide1: HTMLElement | null = document.querySelector('.p-benefit__splide');
  const splide2: HTMLElement | null = document.querySelector('.p-items__splide');

  if (splide1) {
    new Splide('.p-benefit__splide', {
      type: 'loop',
      perPage: 2,
      perMove: 1,
      gap: '3.2rem',
      pagination: false,
      arrows: false,
      pauseOnHover: false,
      autoScroll:  {
        rewind:  true,
        pauseOnHover:  false,
        pauseOnFocus:  false,
        speed: 0.5,
    } ,
      // 767px以下の場合
      breakpoints: {
        767: {
          perPage: 1,
          gap: '1.6rem',
        },
      },
    }).mount({ AutoScroll });
  }

  if (splide2) {
    new Splide('.p-items__splide', {
      type: 'loop',
      perPage: 2,
      perMove: 1,
      gap: '3.2rem',
      pagination: false,
      arrows: false,
      pauseOnHover: false,
      autoScroll:  {
        rewind:  true,
        pauseOnHover:  false,
        pauseOnFocus:  false,
        speed: 0.5,
    } ,
      // 767px以下の場合
      breakpoints: {
        767: {
          perPage: 1,
          gap: '1.6rem',
        },
      },
    }).mount({ AutoScroll });
  }
};

export default splideSetting;
